import DemoLabel from '../../components/DemoLabel/DemoLabel';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';

import CpoProduct from './CpoProduct';
import PedigreeProduct from './PedigreeProduct';

import './ProductPage.scss';

const ProductPage = ({ rightToLeft, watchData, businessData }) => {
  const isCpo = Boolean(watchData?.IsCpo);
  const ProductDetails = isCpo ? CpoProduct : PedigreeProduct;

  return (
    <>
      <DemoLabel />
      <LanguageSwitcher rightToLeft={rightToLeft} isCpo={isCpo} />
      <ProductDetails
        rightToLeft={rightToLeft}
        watchData={watchData}
        businessData={businessData}
      />
    </>
  );
};

export default ProductPage;
